/**
 * Tooltip component
 **/

import React from "react"
import PropTypes from "prop-types"
import {
  StyledCloseIcon,
  StyledTooltip,
  StyledTooltipIcon,
  ToolTipContentContainer,
} from "./styles"
import Icon from "components/Icon"
import { Tooltips } from "./content"
export class ToolTipContent extends React.Component {
  render() {
    const { close, tooltipId } = this.props
    return (
      <ToolTipContentContainer>
        <StyledCloseIcon onClick={close}>
          <Icon variant={"cross_sml"} />
        </StyledCloseIcon>
        {Tooltips[tooltipId]}
      </ToolTipContentContainer>
    )
  }
}

export class AppTooltip extends React.Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
    this.tooltipRef = React.createRef()
  }

  openTooltip = () => {
    this.setState({
      open: true,
    })
  }

  closeTooltip = () => {
    this.setState({
      open: false,
    })
  }

  toggleTooltip = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    const { tooltipId, variant } = this.props
    const { open } = this.state
    return (
      <StyledTooltip
        ref={this.tooltipRef}
        trigger="click"
        interactive
        html={
          <ToolTipContent tooltipId={tooltipId} close={this.closeTooltip} />
        }
        arrow
        arrowSize={17}
        open={open}
        onRequestClose={this.closeTooltip}
        hideOnClick
      >
        <StyledTooltipIcon
          tabIndex={0}
          variant={variant}
          onClick={ev => {
            this.openTooltip()
            ev.preventDefault()
            ev.stopPropagation()
          }}
          onKeyPress={ev => {
            if (ev.key === "Enter") {
              this.toggleTooltip()
              ev.preventDefault()
              ev.stopPropagation()
            }
          }}
        >
          <Icon variant={variant === "covid" ? "covid_icon" : "info"} />
        </StyledTooltipIcon>
      </StyledTooltip>
    )
  }
}

AppTooltip.defaultProps = {
  variant: "info",
}

AppTooltip.propTypes = {
  tooltipId: PropTypes.string.isRequired,
  variant: PropTypes.string,
}

export default AppTooltip
